// extracted by mini-css-extract-plugin
export default {"heading":"ContactUs_heading__L3Uui"};